<template>
  <div class="form-group article" :class="setPlaceholderClasses">
    <div>
      <label class="row">{{ text }}</label>
    </div>
    <textarea
      v-model="contentLocal"
      :id="'input' + _uid"
      class="form-control"
    />

    <b-modal
      id="cheat-sheet-modal"
      size="lg"
      ok-only
      v-model="isCheatSheetVisible"
    >
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="my-4">
            <p class="section-title">img</p>
            <div class="icon-ctn"><i class="fas fa-hashtag"></i></div>

            Class:<span
              tooltip="Applies a rounded filter on the image"
              flow="right"
            >
              rounded
            </span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="my-4">
            <p class="section-title">Animations</p>
            <div class="icon-ctn"><i class="fas fa-hashtag"></i></div>

            Class:<span tooltip="example: wow slideInUp" flow="right">
              wow + "Any class from
              <a href="https://daneden.github.io/animate.css/">Animate css</a>"
            </span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import "@a/imperavi/article/article-editor.js";
import "@a/imperavi/article/plugins/reorder.min.js";
import "@a/imperavi/article/plugins/inlineformat.min.js";
import "@a/imperavi/article/plugins/icons.min.js";
import "@a/imperavi/article/plugins/icons.min.css";
import "@a/imperavi/article/plugins/selector.min.js";
import "@a/imperavi/article/plugins/style.min.js";

import placeholder from "@mixins/placeholder.js";
import commonSnipets from "@a/imperavi/article/plugins/commonSnipets.json";
import iconsList from "@a/imperavi/article/plugins/iconsList.json";
import modal from "@mixins/modal.js";

export default {
  //https://imperavi.com/article/docs/
  name: "volcan-input-article",
  mixins: [placeholder, modal],
  props: {
    text: String,
    type: String,
    json: String,
    snippets: {
      type: Object,
      default() {
        return {};
      },
    },
    templates: {
      type: Object,
      default() {
        return {};
      },
    },
    moduleName: String,
    imageUploadUrl: String,
    content: String,
  },
  data: function () {
    return {
      isCheatSheetVisible: false,
      id: null,
      iconsJson: iconsList,
      commonSnippets: commonSnipets,
      state: {
        focused: false,
      },
      plugins: ["icons", "selector", "reorder", "cheatsheet", "cheatsheet"],
      pluginInlineStyles: {
        button: {
          title:
            '<span style="color: #fff; background: #000; padding: 6px; border-radius: 0;">Button</span>',
          command: "inline.format",
          params: {
            tag: "a",
            attr: {
              class: "btn btn-1",
            },
          },
        },
      },
    };
  },
  model: {
    prop: "content",
    event: "content:change",
  },
  watch: {
    content(newValue) {
      if (this.state.focused) {
        return;
      }
      this.getArticleEditor.editor.content.set(newValue);
    },
  },
  computed: {
    getArticleEditor() {
      return ArticleEditor(this.getId);
    },
    getId() {
      return "#input" + this._uid;
    },
    contentLocal: {
      get: function () {
        return this.content;
      },
      set: function (value) {
        this.$emit("content:change", value);
      },
    },
  },
  mounted() {
    this.prepCheatSheet();
  },
  methods: {
    showCheatSheet() {
      this.isCheatSheetVisible = true;
    },
    initPluginCheatsheet() {
      var self = this;
      ArticleEditor.add("plugin", "cheatsheet", {
        start: function () {
          this.app.toolbar.add("mybutton", {
            title: "Cheat Sheet",
            icon: '<i class="far fa-question-circle"></i>',
            command: "cheatsheet.toggle",
          });
        },
        toggle: function (/*e, $el, params*/) {
          self.showCheatSheet();
        },
      });
    },
    prepCheatSheet() {
      this.initPluginCheatsheet();

      var json = $.extend(
        JSON.parse(JSON.stringify(this.commonSnippets)),
        JSON.parse(JSON.stringify(this.snippets))
      );

      var snipets = { json };

      var self = this;
      ArticleEditor(this.getId, {
        toolbar: {
          sticky: false,
        },
        plugins: self.plugins,
        snippets: snipets,
        templates: self.templates,
        icons: {
          items: self.iconsJson,
        },
        inline: self.pluginInlineStyles,
        // style: self.pluginStylesSettings,
        // inlineformat: self.pluginFormatSettings,
        subscribe: {
          "editor.focus": function () {
            self.state.focused = true;
          },
          "editor.blur": function () {
            self.state.focused = false;
          },
          "editor.content.change": function (val) {
            self.contentLocal = val.params.html;
          },
        },
        image: {
          upload: "/api/media/uploadfilesredactor/",
        },
      });
    },
  },
};
</script>

<style lang="css">
@import "../../../Assets/imperavi/article/article.css";
</style>

<style lang="scss">
@import "../../../Assets/imperavi/article/styles/customSnipets.scss";
@import "../../../Assets/imperavi/article/styles/baseTemplates.scss";
@import "../../../Assets/imperavi/article/styles/customStyles.scss";
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-article.vue